import BaseAPI from "./base/base-api";
import httpClient from "@/apis/base/axios-httpclient";
import { isBuffer } from "lodash";

class AssetAPI extends BaseAPI {
  constructor() {
    super();
  }
  apiName = "Business";
  controllerName = "Asset";

  /**
   * Author: ĐVThi
   * Date create: 01/03/2021
   * Tìm kiếm tài sản theo nhiều đối tượng
   */
  getAssetDetailByID(assetID) {
    let request = {
      url: [this.getAPIUrl(), assetID].join("/"),
    };
    return httpClient.getAsync(request);
  }

  /**
   * @override: Lấy dữ liệu danh sách
   * @author vvkiet - 17.03.2021
   */
  getList(payload) {
    // URL mặc định
    let url = this.getAPIUrl() + "/list";

    // Nếu là form bảo dưỡng
    if (payload.type == "maintain") {
      url = this.getAPIUrl() + "/ListAssetMaintain";
    }
    // Nếu là form sửa chữa
    else if (payload.type == "repair") {
      url = this.getAPIUrl() + "/ListAssetRepair";
    } else if (payload.type == "lost") {
      url = this.getAPIUrl() + "/ListAssetLost";
    }
    // Nếu là form hủy
    else if (payload.type == "cancel") {
      url = this.getAPIUrl() + "/ListAssetCancel";
    }
    // Nếu là form hủy
    else if (payload.type == "liquidated") {
      url = this.getAPIUrl() + "/ListAssetLiquidated";
    } else if (payload.type == "organizationAssetUsing") {
      url = this.getAPIUrl() + "/ListOrganizationUnitUsingAsset";
    } else if (payload.type == "assetQuickSearch") {
      url = this.getAPIUrl() + "/AssetQuickSearch";
    }

    // Build tham số
    let request = {
      url: url,
      data: payload,
    };

    // Call api
    return httpClient.postAsync(request);
  }
  /*
   *   Lấy misa code ID khi chọn lại loại tài sản
   *   pvduy 06/04/2021
   */
  getAutoID(payload) {
    // Build tham số
    let request = {
      url: [this.getAPIUrl(), "auto-id", payload].join("/"),
    };
    // Call api
    return httpClient.getAsync(request);
  }
  /**
   * Lấy ds tài sản theo nhân viên đang sử dụng
   * created by ntphong 25/3/2021
   */
  getAssetByEmployee(employeeID) {
    let request = {
      url: [this.getAPIUrl(), "employee", employeeID].join("/"),
    };
    return httpClient.getAsync(request);
  }

  /**
   * Lấy ds tài sản phân trang theo nhân viên đang sử dụng
   * created by ntphong 25/3/2021
   */
  getAssetByEmployeePaging(payload) {
    let request = {
      url: [this.getAPIUrl(), "employee-paging"].join("/"),
      data: payload,
    };

    // Call api
    return httpClient.postAsync(request);
  }
  /**
   * Api lấy mã code tự động tăng của asset.
   * pvduy 29/04/2021: thi công CR tăng mã
   * @param {*} payload
   * @returns
   */
  getAssetCodeAuto(payload) {
    let request = {
      url: [this.getAPIUrl(), "auto-asset-code"].join("/"),
      data: payload,
    };
    // Call api
    return httpClient.postAsync(request);
  }

  getTotal() {
    let request = {
      url: [this.getAPIUrl(), "total"].join("/"),
    };
    return httpClient.getAsync(request);
  }
}

export default new AssetAPI();
